import React from 'react';
import {Route, Switch} from 'react-router-dom';

import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import ViewMessage from './components/ViewMessage/ViewMessage';

/**
 * Main entrypoint for Webmail app
 * @return {ReactElement}
 */
function App() {
  return (
    <ErrorBoundary>
      <Switch>
        <Route exact path="/message" component={ViewMessage} />
      </Switch>
    </ErrorBoundary>
  );
}

export default App;
